// ----------------------------------------------------------------------------
// Component: Quiz Block
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts

// Styles
import './_quiz-page.scss';


// Variables
const VARIANT_INPUT = '.selector-wrapper';
const SUBMIT_BUTTON = '.button__quiz';
const VARIANT_SELECTED_WRAPPER = '.selector-wrapper';
const SELLING_PLAN_INPUT = '.selector-wrapper';
const localeUrl = window.localeUrl;

// Change variant
function initQuizVariantSelector() {
    const btnAddToCartQuiz = document.querySelector(SUBMIT_BUTTON);
    const colorVariantRadio = document.querySelectorAll('input[name="variantColor"]');
    const sellingPlanSelect = document.querySelector('select[name="sellingPlan"]');
    const variantTitle = document.querySelector('.quiz__variant-selected');
    const selectTag = document.querySelector('.select__tag');

    if(colorVariantRadio != null) {
        for (const colorVariant of colorVariantRadio) {
            if (colorVariant != null) {
                colorVariant.addEventListener('change', showSelectedVariant);
            }
        }
    }

    function showSelectedVariant(e) {
        if (this.checked) {
            variantTitle.innerText = this.dataset.optionTitle;
        }
    }

    if(sellingPlanSelect != null) {
        sellingPlanSelect.value = '1408958566';
        sellingPlanSelect.addEventListener('change', toggleSelectTag);
    }

    function toggleSelectTag(e) {
        if(this.value != '1408958566' ) {
            selectTag.classList.add('select__tag--hidden');
        } else {
            selectTag.classList.remove('select__tag--hidden');
        }
    }

    if (btnAddToCartQuiz != null) {
        btnAddToCartQuiz.addEventListener('click', () => {
            let selectedColorVariant;
            let sellingPlan = sellingPlanSelect.value;
            let discountCode = 'test';

            // Check for variant selection
            for (const colorVariant of colorVariantRadio) {
                if (colorVariant.checked) {
                    selectedColorVariant = colorVariant.value;
                    break;
                }
            }

            let cartLink = 'https://www.shopflamingo.com/cart/add?items[][id]='+ selectedColorVariant + '&items[][quantity]=1&items[][selling_plan]='+ sellingPlan + '&discount=TEST&return_to=/checkout';

            //console.log(cartLink);
            window.location.href = cartLink;
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {
    initQuizVariantSelector();
});
